import type { FC } from "react"
import { useCreation } from "ahooks-v2"
import GeographicRange from "@/components/GeographicRange"
import type { StoreRanking } from "@/api"
import { useControllerModel } from "@/models"
import { getBranchThemeColors } from "@/util/commonUtils"
import "./index.scss"
// ==============================================
interface BranchAoiProps {
  visible?: boolean
  storeList: StoreRanking[] | null
  unlockedShow: boolean
  lockedShow: boolean
}
const BranchAoi: FC<BranchAoiProps> = ({
  visible = false,
  storeList,
  unlockedShow,
  lockedShow,
}) => {
  const { theme } = useControllerModel()

  // 获取网点主题颜色
  const colorTheme = useCreation(() => {
    return getBranchThemeColors()
    // eslint-disable-next-line
  }, [theme])

  // 处理后的aoi数据
  const aoiData = useCreation(() => {
    const list: any = []
    const unlockedList: any = []
    const lockedList: any = []
    if (storeList?.length) {
      for (let i = 0; i < storeList.length; i++) {
        const item = storeList[i]
        if (item?.aoiGeometry?.length) {
          const data = {
            id: item.poiId,
            color: item.unlocked ? colorTheme.unlockedColor : colorTheme.lockedColor,
            aoiPolygon: item.aoiGeometry,
          }
          if (item.unlocked) {
            unlockedList.push(data)
          } else {
            lockedList.push(data)
          }
        }
      }
    }
    if (unlockedShow) {
      list.push(...unlockedList)
    }
    if (lockedShow) {
      list.push(...lockedList)
    }
    return list
  }, [storeList, colorTheme, unlockedShow, lockedShow])

  return (
    <GeographicRange
      id="single-store-polygon"
      visible={visible && aoiData?.length}
      data={aoiData as any}
      strokeWidth={2}
      zIndex={10}
    />
  )
}

export default BranchAoi
